import type { SxProps, Theme } from "@mui/material/styles";

/**
 * Styles for API-injected HTML (description, synopsis).
 * Tailwind preflight resets lists; these rules restore indentation and list markers.
 */
export const regulationRichHtmlContentSx: SxProps<Theme> = {
  fontSize: "14px",
  lineHeight: 1.6,
  "& em, & i": {
    fontStyle: "italic !important",
  },
  "& strong, & b": {
    fontWeight: "bold !important",
  },
  "& p": {
    marginTop: 0,
    marginBottom: "0.5em",
  },
  "& ul": {
    display: "block",
    listStyleType: "disc",
    paddingLeft: "1.5em",
    marginTop: 0,
    marginBottom: "0.5em",
  },
  "& ol": {
    display: "block",
    listStyleType: "decimal",
    paddingLeft: "1.5em",
    marginTop: 0,
    marginBottom: "0.5em",
  },
  "& li": {
    display: "list-item",
  },
  "& ul ul": {
    listStyleType: "circle",
  },
  "& ol ol": {
    listStyleType: "lower-alpha",
  },
  "& blockquote": {
    marginTop: 0,
    marginBottom: "0.5em",
    marginLeft: "1em",
    paddingLeft: "1em",
    borderLeft: "3px solid #e5e7eb",
  },
  // Quill-style indent classes often used in CMS HTML
  "& .ql-indent-1": { paddingLeft: "3em" },
  "& .ql-indent-2": { paddingLeft: "6em" },
  "& .ql-indent-3": { paddingLeft: "9em" },
  "& .ql-indent-4": { paddingLeft: "12em" },
  "& .ql-indent-5": { paddingLeft: "15em" },
  "& .ql-indent-6": { paddingLeft: "18em" },
  "& .ql-indent-7": { paddingLeft: "21em" },
  "& .ql-indent-8": { paddingLeft: "24em" },
  "& br": {
    display: "block",
    content: '""',
    marginTop: "0.5em",
  },
};

/** Prepare synopsis HTML: strip newlines and literal \\n without breaking inline styles. */
export function normalizeSynopsisHtml(raw: string): string {
  return raw
    .trim()
    .replace(/\\n/g, "")
    .replace(/\r\n/g, "")
    .replace(/\n/g, "");
}
